module.exports = __webpack_public_path__ + "static/media/hotspot-bind.b4fce5d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hotspot-bind.mp4
// module id = 9P0c
// module chunks = 0